import { graphql } from 'gql/generated/gql'

export const CREATE_BUSINESS_CLIENTS_ROUTE_SERVICES_SCHEDULE_PRICE = graphql(`
  mutation CreateBusinessClientsRouteServicesSchedulePrice(
    $input: CreateBusinessClientsRouteServicesSchedulePriceInput!
  ) {
    createBusinessClientsRouteServicesSchedulePrice(input: $input)
  }
`)
